<template>
  <div class="work-sidebar-wrapper">
    <v-navigation-drawer
      v-if="$vuetify.breakpoint.mdAndUp"
      ref="navigationDrawer"
      :class="navigationDrawerClass"
      :mini-variant.sync="mini"
      permanent
    >
      <WorkSidebarList 
        :mini="mini"
        @onClickSidebarIcon="mini = !mini"
      />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-else
      ref="sidebarNavigationDrawer"
      :class="navigationDrawerClass"
      permanent
    >
      <WorkSidebarList />
    </v-navigation-drawer>
  </div>
</template>

<script>
import WorkSidebarList from '@/components/sidebar_components/WorkSidebarList.vue';
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue';
import store from "@/store";

export default {
  name: 'WorkSidebar',
  components: {
    WorkSidebarList,
  },
  props: {
    shadow: { type: Boolean, default: false },
  },
  setup(props) {
    const mini = ref(false);
    const navigationDrawer = ref(null);
    const sidebarNavigationDrawer = ref(null);
    
    onClickOutside(sidebarNavigationDrawer, event => {
      store.dispatch('sidebarDrawer/setSidebarDrawerIsOpen', false);
    });
    
    return { mini, navigationDrawer, sidebarNavigationDrawer }
  },
  computed: {
    navigationDrawerClass() {
      return {
        'work-sidebar': true, 
        'work-sidebar-shadow': this.shadow,
        'work-sidebar--mobile': this.$vuetify.breakpoint.smAndDown,
        'work-sidebar--desktop': this.$vuetify.breakpoint.mdAndUp,
      }
    },
    sidebarDrawerIsOpen() {
      return store.getters['sidebarDrawer/sidebarDrawerIsOpen'];
    }
  },
  watch: {
    mini(value) {
      store.dispatch('sidebarDrawer/setSidebarDrawerIsOpen', !value);
    },
  }, 
}
</script>

<style lang="scss" scoped>
.work-sidebar-wrapper {
  .work-sidebar{
    background-color: $sidebar-background-color;
    border-bottom-right-radius: 8px;
    height: max-content !important;

    &.work-sidebar--mobile {

      &.v-navigation-drawer--open {
        width: 100% !important;
      }
    }

    &.work-sidebar--desktop {

      &.v-navigation-drawer--open {
        width: max-content !important;
      }
    }

    &.work-sidebar-shadow{
      box-shadow: $menu-box-shadow !important;
    }
    
    &.v-navigation-drawer--mini-variant{
      width: max-content !important;
    }
  }
}
</style>